<template>
  <div class="projects_section">
    <div class="title_page">
      <div class="container">
        <div class="wrap_title" v-if="get_works_title.seo">
          <div class="title_text">
            <h1>{{get_works_title.seo.title}}</h1>
          </div>
          <div class="title_desc">
            <p>
             {{get_works_title.seo.desc}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="main_page" v-if="get_project_list">
      <div class="container">
        <div class="main_slider_proj">
          <div class="row"  v-for="main_slide in slice_project.slice(0,1)" :key="main_slide.id">
            <div class="col-lg-7">
              <div class="div_sli">
                <div
                  class="uk-position-relative uk-visible-toggle uk-dark"
                  tabindex="-1"
                  uk-slideshow="min-height: 250; max-height: 400;autoplay: true;autoplay-interval:5000;"
                >
                  <ul class="uk-slideshow-items">
                    <li v-for="image in main_slide.images" :key="image.id">
                      <img
                        :src="image.url"
                        :alt="image.name"
                        uk-cover
                      />
                    </li>
                  </ul>

                  <a
                    class="uk-position-center-left uk-position-small uk-hidden-hover"
                    href="#"
                    uk-slidenav-previous
                    uk-slideshow-item="previous"
                  ></a>
                  <a
                    class="uk-position-center-right uk-position-small uk-hidden-hover"
                    href="#"
                    uk-slidenav-next
                    uk-slideshow-item="next"
                  ></a>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="text_sli">
                <h1 class="t2">{{main_slide.title}}</h1>
                <p class="desc" v-html="main_slide.description"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="other_slider">
          <div class="row">
            <div class="col-lg-6 other_pd" v-for="other_slide in slice_other_project.slice(1)" :key="other_slide.id">
              <div class="div_sli">
                <div
                  class="uk-position-relative uk-visible-toggle uk-dark"
                  tabindex="-1"
                  uk-slideshow="min-height: 250; max-height: 400;autoplay: true;autoplay-interval:5000;"
                >
                  <ul class="uk-slideshow-items">
                    <li v-for="image in other_slide.images" :key="image.if">
                      <img
                        :src="image.url"
                        :alt="image.name"
                        uk-cover
                      />
                    </li>
                  </ul>

                  <a
                    class="uk-position-center-left uk-position-small uk-hidden-hover"
                    href="#"
                    uk-slidenav-previous
                    uk-slideshow-item="previous"
                  ></a>
                  <a
                    class="uk-position-center-right uk-position-small uk-hidden-hover"
                    href="#"
                    uk-slidenav-next
                    uk-slideshow-item="next"
                  ></a>
                </div>
                <div class="text_slider_other">
                    <h1 >{{other_slide.title}}</h1>
                <p v-html="other_slide.description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "projectApp",
     computed: {
    ...mapGetters({
      get_project_list: "get_project_list",
      get_works_title:'get_works_title'
    }),
      slice_project(){
      return Array.prototype.slice.call(this.get_project_list);
    },
    slice_other_project(){
      return Array.prototype.slice.call(this.get_project_list);
    }
  },
  methods: {
    ...mapActions({
      projects_api: "projects_api",
      works_title_api:'works_title_api'
    }),
  },
  mounted() {
    this.works_title_api();
    this.projects_api();
  },
};
</script>
<style lang="scss" scoped>
.projects_section {
  background-image: url("~@/assets/paget.svg");
  background-position: 73vw 0vh;
  background-repeat: no-repeat;
  background-size: 38vw auto;
  .main_slider_proj {
    .text_sli {
      padding-top: 55px;
      padding-right: 20px;
      padding-left: 30px;
      p {
        margin-bottom: 5px;
      }
    }
  }
  .other_slider {
    margin-top: 100px;
    .other_pd{
        margin-bottom: 80px;
        padding: 5px;
    }
    .text_slider_other {
            padding: 0px 0px 0px 40px;
      h1 {
        font-size: 1.5rem;
        font-weight: 700;
        margin: 0;
        margin-top: 20px;
        margin-bottom: 4px;
        color: white;
        font-family: "Oswald", sans-serif;
        text-transform: uppercase;
      }
      p {
        font-size: 12px;
        text-transform: uppercase;
        font-family: "Roboto", sans-serif;
        letter-spacing: 1px;
        font-weight: 300;
        margin: 0;
        color: var(--active_color);
      }
    }
  }
}
 .title_page {
    padding: 55px 0px;
    .wrap_title {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .title_text {
        flex: 0 0 40%;
        h1 {
          line-height: 1.1;
          font-size: 5rem;
          font-family: "Oswald", sans-serif;
          text-transform: uppercase;
          font-weight: 700;
          margin: 0;
          color: white;
          position: relative;
          padding-bottom: 40px;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0px;
            width: 80px;
            height: 4px;
            background-color: var(--active_color);
          }
        }
      }

      .title_desc {
        padding: 0;
        max-width: 520px;
        padding-left: 40px;
        p {
          margin: 0;
          padding: 0px 20px 30px 00px;
          font-size: 16px;
          font-weight: 300;
          color: #d8d8d8;
          font-family: "Roboto", sans-serif;
        }
      }
    }
  }
   @media(max-width:992px){
    .title_page .wrap_title .title_text h1 {
    line-height: 1.1;
    font-size: 3rem;
    padding-bottom: 20px;
    width: 100%;
}
.title_page .wrap_title .title_desc p {
    margin: 0;
    padding: 0px 10px 8px 0px;
    font-size: 13px;
    font-weight: 300;
    line-height: 22px;
}
  }
    @media(max-width:767px){
    .title_page .wrap_title .title_text h1 {
    line-height: 1.1;
    font-size: 2rem;
    padding-bottom: 20px;
    width: 100%;
}
.title_page .wrap_title .title_desc p {
    margin: 0;
    padding: 0px 10px 8px 0px;
    font-size: 12px;
    font-weight: 300;
    line-height: 22px;
}
.title_page .wrap_title {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: column;
}
.title_page .wrap_title .title_desc {
    padding: 0;
    flex: 0 0 50%;
    max-width: 100%;
    padding-left: 0px;
    padding-top: 20px;
}
.projects_section .main_slider_proj .text_sli {
    padding-top: 15px;
    padding-right: 10px;
    padding-left: 0px;
}
.projects_section .main_slider_proj .text_sli{
    padding-top: 15px;
    padding-right: 10px;
    padding-left: 0px;
}
.projects_section .other_slider .other_pd {
    margin-bottom: 50px;
    padding: 5px;
}
.projects_section .other_slider .other_pd {
    margin-bottom: 50px;
    padding: 5px;
}
.projects_section .other_slider .text_slider_other{
    padding: 0px 0px 0px 10px;
}
  }
</style>
